import { useI18n } from "../../contexts/I18nContext";

/**
 * Left Navigation for Password Manager
 * Shows 3 pages: Security, Passwords, Access Management
 */
export default function LeftNav({ activePage, onNavigate, isUnlocked }) {
  const { t } = useI18n();
  const navItems = [
    {
      id: "security",
      label: t("Sicherheit & Zugriff"),
      enabled: true,
    },
    {
      id: "passwords",
      label: t("Passwörter"),
      enabled: isUnlocked,
    },
    {
      id: "access",
      label: t("Zugriffsverwaltung"),
      enabled: isUnlocked,
    },
  ];

  return (
    <div
      style={{
        width: "220px",
        backgroundColor: "#f5f5f5",
        borderRight: "1px solid #ddd",
        padding: "20px 0",
      }}
    >
      <h3
        style={{
          padding: "0 20px",
          marginBottom: "20px",
          fontSize: "16px",
          fontWeight: "600",
        }}
      >
        {t("Passwort-Manager")}
      </h3>

      <nav>
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => item.enabled && onNavigate(item.id)}
            disabled={!item.enabled}
            style={{
              display: "block",
              width: "100%",
              padding: "12px 20px",
              textAlign: "left",
              border: "none",
              backgroundColor:
                activePage === item.id ? "#0078d4" : "transparent",
              color: item.enabled
                ? activePage === item.id
                  ? "#fff"
                  : "#333"
                : "#999",
              cursor: item.enabled ? "pointer" : "not-allowed",
              fontSize: "14px",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => {
              if (item.enabled && activePage !== item.id) {
                e.target.style.backgroundColor = "#e6e6e6";
              }
            }}
            onMouseLeave={(e) => {
              if (activePage !== item.id) {
                e.target.style.backgroundColor = "transparent";
              }
            }}
          >
            {item.label}
            {!item.enabled && " 🔒"}
          </button>
        ))}
      </nav>
    </div>
  );
}
